if (!customElements.get('product-abonnement-selecteur')) {
  customElements.define(
    'product-abonnement-selecteur',
    class ProductAbonnementSelecteur extends HTMLElement {
      constructor() {
        super();
        this.plans = JSON.parse(this.querySelector('[data-plans]').textContent);
        this.prixEl = this.querySelector('[data-prix]');
        this.economieEl = this.querySelector('[data-economie]');
        this.renouvellementEl = this.querySelector('[data-renouvellement]');
        this.inputCache = this.querySelector('[data-selling-plan-input]');
        this.addEventListener('change', this.onChange.bind(this));
        this.mettreAJour();
      }

      valeursSelectionnees() {
        const groupes = {};
        this.querySelectorAll('input[type="radio"]:checked').forEach((input) => {
          groupes[input.dataset.optionIndex] = input.value;
        });
        return Object.keys(groupes)
          .sort((a, b) => Number(a) - Number(b))
          .map((cle) => groupes[cle]);
      }

      onChange() {
        this.mettreAJour();
      }

      mettreAJour() {
        const selection = this.valeursSelectionnees();
        const planCorrespondant = this.plans.find(
          (plan) => JSON.stringify(plan.options) === JSON.stringify(selection),
        );

        if (!planCorrespondant) return;

        this.inputCache.value = planCorrespondant.id;

        // options[0] est toujours la fréquence de facturation (Mensuel/Annuel),
        // voir l'ordre des selling plan groups créés côté admin.
        const frequence = planCorrespondant.options[0];
        const suffixe = frequence === 'Annuel' ? ' / an' : ' / mois';
        this.prixEl.textContent = `${planCorrespondant.prix}${suffixe}`;
        this.renouvellementEl.textContent =
          frequence === 'Annuel'
            ? 'Renouvellement automatique chaque année'
            : 'Renouvellement automatique chaque mois';

        if (frequence === 'Annuel') {
          const optionsMensuel = [...planCorrespondant.options];
          optionsMensuel[0] = 'Mensuel';
          const planMensuel = this.plans.find(
            (plan) => JSON.stringify(plan.options) === JSON.stringify(optionsMensuel),
          );

          if (planMensuel) {
            const economie = planMensuel.montant * 12 - planCorrespondant.montant;
            const economieFormatee = economie.toLocaleString('fr-FR', {
              style: 'currency',
              currency: 'EUR',
            });
            this.economieEl.textContent = `Économisez ${economieFormatee}/an (-20%) par rapport au mensuel`;
            this.economieEl.hidden = false;
          }
        } else {
          this.economieEl.hidden = true;
        }
      }
    },
  );
}
